import {getBrandConfig} from "@/brand";
import store from "../store";
import {GameToBrandMap} from "@/brand/brandConfig";

export function setBrandConfig() {
    if (store.state.brandConfig && store.state.productId) {
        return;
    }
    
    const brandConfig = getBrandConfigFromGameParameter();
    store.commit('setBrandConfig', brandConfig);
}

export function getBrandConfigFromGameParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const productId = urlParams.get('productId');
    if (!store.state.productId) {
        store.commit('setProductId', productId);
    }
    
    if (productId && GameToBrandMap.has(Number(productId))) {
        return getBrandConfig(GameToBrandMap.get(Number(productId)));
    } else {
        // Uncomment one of the options below to force a specific brand config while testing:
        //return getBrandConfig(3);  // VodacomStopClock
        //return getBrandConfig(5);  // VodacomQuizInc
        //return getBrandConfig(6);  // VodacomUnlockThree
      //  return getBrandConfig(8);  // VodacomFantasyDribble
        // return getBrandConfig(18); // VodacomBeatTheJams
        //return getBrandConfig(21); // VodacomHeadToHead
        //return getBrandConfig(25); // VodacomDailyFive
       // return getBrandConfig(26); // VodacomCricketZone
       // return getBrandConfig(27); // VodacomMotorsportZone
        //return getBrandConfig(28); // VodacomRugbyZone
      //  return getBrandConfig(88); // VodacomRoFantasyDribble
        return getBrandConfig(36); // VodacomChessMasters
        //return getBrandConfig(38); // VodacomOpenly
        //return getBrandConfig(39); // VodacomGameZar
       // return getBrandConfig(5); // Default to Quiz Inc
    }
}


